import { render, staticRenderFns } from "./CardInfoBL.vue?vue&type=template&id=8f4d884c&scoped=true&"
import script from "./CardInfoBL.vue?vue&type=script&lang=js&"
export * from "./CardInfoBL.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoBL.vue?vue&type=style&index=0&id=8f4d884c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4d884c",
  null
  
)

export default component.exports